import {Actions, Keys} from '../constants';
import Immutable from 'immutable';
import api from '../apiClient';
import _ from 'lodash';
import {doLogout} from '../action-creators/login-actions';


export const MutationConstants = {
    SETS:'sets',
    PLAIN:'plain',
    SET:'set',
    ADDED:'added',
    REMOVED:'removed',
    UNMODIFIED:Symbol('UNMODIFIED'),
    UNDEFINED:Symbol('UNDEFINED'),
}

// Custom immutable that converts to collection to set
export function toImmutable(obj) {
    return Immutable.fromJS(obj, (key, value) => {
        var isIndexed = Immutable.Iterable.isIndexed(value);
        return isIndexed ? value.toSet() : value.toMap();
    })
}

// should return if value is added/removed in case of set, or changed in case of plain
export function getPropMutationState(item, prop, mutation, appliedValue, UNMODIFIED, ADDED_CHANGED, REMOVED) {
    let propMutation = mutation.get(prop, null);
    if ( !propMutation ) {
        return UNMODIFIED;
    }
    let currentProp = item.get(prop, MutationConstants.UNDEFINED);
    // if prop is a iterable
    if ( Immutable.Set.isSet(currentProp)) {
        const removed = propMutation.get(MutationConstants.REMOVED, Immutable.Set());
        if ( removed.contains(appliedValue)) {
            return REMOVED;
        }
        const added = propMutation.get(MutationConstants.ADDED,Immutable.Set());
        return added.contains(appliedValue)?ADDED_CHANGED:UNMODIFIED;

    } else if ( Immutable.Iterable.isIterable(currentProp) ){
        throw new Error("Unsupported property type in object. Only Set and primitives are allowed:  "+item.toJSON());
    }
    const mutated =  propMutation.get(MutationConstants.SET, MutationConstants.UNMODIFIED);
    return mutated===MutationConstants.UNMODIFIED?UNMODIFIED:ADDED_CHANGED;
}

export function applyPropMutation(item, prop, mutation) {
    let propMutation = mutation.get(prop, null);
    let currentProp = item.get(prop, MutationConstants.UNDEFINED);
    if( !propMutation) {
        return currentProp;
    }
    // if prop is a iterable
    if ( Immutable.Set.isSet(currentProp)) {
        const removed = propMutation.get(MutationConstants.REMOVED, Immutable.Set());
        const added = propMutation.get(MutationConstants.ADDED,Immutable.Set());
        return currentProp.subtract(removed).union(added);
    } else if ( Immutable.Iterable.isIterable(currentProp) ){
        throw new Error("Unsupported property type in object. Only Set and primitives are allowed:  "+item.toJSON());
    }
    const mutated =  propMutation.get(MutationConstants.SET, MutationConstants.UNMODIFIED);
    return mutated===MutationConstants.UNMODIFIED?currentProp:mutated;

}
export function initSetProp(currentMutation, prop) {
    if( !currentMutation) {
        currentMutation = Immutable.Map();
    }
    if( !currentMutation.hasIn([prop, MutationConstants.ADDED])) {
        currentMutation = currentMutation.setIn([prop, MutationConstants.ADDED], Immutable.Set());
    }
    if( !currentMutation.hasIn([prop, MutationConstants.REMOVED])) {
        currentMutation = currentMutation.setIn([prop, MutationConstants.REMOVED], Immutable.Set());
    }
    return currentMutation;
}
export function addToSet(item, currentMutation, prop, value) {
    currentMutation = initSetProp(currentMutation, prop);
    if( !item.get(prop).contains(value)) {
        // it is NOT in the real object, so add to added
        return currentMutation.updateIn([prop, MutationConstants.ADDED], (set) => set.add(value) )
    } else {
        // it is in the real object, so remove from removed
        return currentMutation.updateIn([prop, MutationConstants.REMOVED], (set) => set.remove(value) )
    }
}

export function removeFromSet(item, currentMutation, prop, value) {
    currentMutation = initSetProp(currentMutation, prop);
    if( item.get(prop).contains(value)) {
        // it is in the real object, so add ro removed
        return currentMutation.updateIn([prop, MutationConstants.REMOVED], (set) => set.add(value) )
    } else {
        // it is in the the mutation, so remove from added
        return currentMutation.updateIn([prop, MutationConstants.ADDED], (set) => set.remove(value) )
    }
}

export function setInPlain(item, currentMutation, prop, value) {
    const current = item.get(prop, MutationConstants.UNDEFINED);
    if ( current===MutationConstants.UNDEFINED || current!==value) {
        return currentMutation.setIn([prop, MutationConstants.SET], value )
    } else {
        // Since we don't allow add/remove at the same time as set this to empty map
        // to clear modifications
        return currentMutation.setIn([prop], Immutable.Map())
    }
}
export function togglePlain(item, currentMutation, prop, value) {
    const currentValue = applyPropMutation(item,  prop,  currentMutation);
    if ( currentValue === value ) {
        return setInPlain(item, currentMutation, prop, value===true?false:null);
    } else {
        return setInPlain(item, currentMutation, prop, value);
    }
}
export function toggleInSet(item, currentMutation, prop, value) {
    const currentValues = applyPropMutation(item, prop, currentMutation);
    if( currentValues.contains(value)) {
        return removeFromSet(item, currentMutation, prop, value)
    } else {
        return addToSet(item, currentMutation, prop, value)
    }

}
export function doTogglePlain(editorId, itemType, item, currentMutation, prop, value) {
    if( !currentMutation) {
        currentMutation = Immutable.Map();
    }
    currentMutation = togglePlain(item, currentMutation, prop, value);
    const path = [editorId, itemType, item.get(Keys.ID)];
    const action = {type: Actions.MUTATION_SAVE, payload: {path: path, mutation:currentMutation}};
    return  action;

}
export function doToggleInSet(editorId, itemType, item, currentMutation, prop, value) {
    if( !currentMutation) {
        currentMutation = Immutable.Map();
    }
    currentMutation = initSetProp(currentMutation, prop);
    currentMutation = toggleInSet(item, currentMutation, prop, value);
    const path = [editorId, itemType, item.get(Keys.ID)];
    const action = {type: Actions.MUTATION_SAVE, payload: {path: path, mutation:currentMutation}};
    return  action;
}

//
// Multiples
//
export function isToggledOn(items, mutations, prop, value) {
    const firstItem = items.first();
    if ( typeof firstItem.get(Keys.ID) !== 'string') {
        throw new Error("Id  is not of type string in "+firstItem.toJSON());
    }
    let firstMutation = mutations.get(firstItem.get(Keys.ID), Immutable.Map());
    let result = applyPropMutation(firstItem, prop, firstMutation);
    return Immutable.Set.isSet(result)?result.contains(value):result===value;
}

export function setMultiple(items, mutations, prop, value) {
    let result = {};
    items.forEach((item) => {
        result[item.get(Keys.ID)] = setInPlain(item, mutations.get(item.get(Keys.ID), Immutable.Map()), prop, value);
    });
    return toImmutable(result);
}
export function addToMultipleSets(items, mutations, prop, value) {
    let result = {};
    items.forEach((item) => {
        result[item.get(Keys.ID)] = addToSet(item, mutations.get(item.get(Keys.ID), Immutable.Map()), prop, value);
    });
    return toImmutable(result);
}

export function removeFromMultipleSets(items, mutations, prop, value) {
    let result = {};
    items.forEach((item) => {
        result[item.get(Keys.ID)] = removeFromSet(item, mutations.get(item.get(Keys.ID), Immutable.Map()), prop, value);
    });
    return toImmutable(result);
}

export function doToggleInMultipleSets(editorId, itemType, items, mutations, prop, value) {
    if(!mutations) {
        mutations = Immutable.Map();
    }
    if( isToggledOn(items, mutations, prop, value)) {
        mutations = removeFromMultipleSets(items, mutations, prop, value);
    } else {
        mutations = addToMultipleSets(items, mutations, prop, value);
    }
    return {type: Actions.MUTATIONS_SAVE, payload:{path:[editorId,itemType], mutations:mutations}}
}
export function doToggleMultiple(editorId, itemType, items, mutations, prop, value) {
    if(!mutations) {
        mutations = Immutable.Map();
    }
    if( isToggledOn(items, mutations, prop, value)) {
        mutations = setMultiple(items, mutations, prop, value===true?false:null);
    } else {
        mutations = setMultiple(items, mutations, prop, value);
    }
    return {type: Actions.MUTATIONS_SAVE, payload:{path:[editorId,itemType], mutations:mutations}}
}


const  _saveItems = (editorId) => (dispatch, getState) => {
    const itemMutations = getState().mutationsState.getIn([editorId, Keys.MutationType.ITEM],Immutable.Map())
                                        .filter(mutation => {
                                            return mutation.has(Keys.Item.HIDDEN) || mutation.has(Keys.Item.DIFFICULTY_TAGS)
                                        });
    if ( itemMutations.isEmpty()) {
        return [];
    }
    dispatch({type:Actions.PATCH_ITEMS + '_REQUEST'});
    return api.patchItems(itemMutations.toJS()).then(
        response => {
            dispatch(
                {
                    type:Actions.PATCH_ITEMS + '_SUCCESS',
                    payload:{[Keys.StoreSliceData.ITEMS]:response.data}
                }
            );
            // send the actual data, so that items and assignees can update their IN_WORK_SESSION
            dispatch(
                {
                    type:Actions.ITEMS_UPDATED,
                    payload:{
                        [Keys.StoreSliceData.ITEMS]:getState().itemsState.get(Keys.StoreSliceData.ITEMS)
                    }
                }
            );
            return [Keys.MutationType.ITEM]; // signal that we have updated items


        }
    ).catch(
        error => {
            dispatch({type:Actions.PATCH_ITEMS + '_FAILURE', payload:{message:error.message}});
            if (error.code === 401) {
                return dispatch(doLogout())
            }
            return false;
        }
    );
}

const _saveAssignees = (editorId) => (dispatch, getState) =>  {
    const assigneeMutations = getState().mutationsState.getIn([editorId, Keys.MutationType.ASSIGNEE],Immutable.Map())
        .filter(mutation => {
            return mutation.has(Keys.Assignee.GROUPS) || mutation.has(Keys.Assignee.ACTIVE)
        });
    if ( assigneeMutations.isEmpty()) {
        return [];
    }
    dispatch({type:Actions.PATCH_ASSIGNEES + '_REQUEST'});
    return api.patchAssignees(assigneeMutations.toJS()).then(
        response => {
            dispatch(
                {
                    type:Actions.PATCH_ASSIGNEES + '_SUCCESS',
                    payload:{[Keys.StoreSliceData.ASSIGNEES]:response.data}
                }
            );
            // send the actual data, so that items and assignees can update their IN_WORK_SESSION
            dispatch(
                {
                    type:Actions.ASSIGNEES_UPDATED,
                    payload:{
                        [Keys.StoreSliceData.ASSIGNEES]:getState().assigneesState.get(Keys.StoreSliceData.ASSIGNEES)
                    }
                }
            );
            return [Keys.MutationType.ASSIGNEE]; // signal that we have updated assignees
        }

    ).catch(
        error => {
            dispatch({type:Actions.PATCH_ASSIGNEES + '_FAILURE', payload:{message:error.message}});
            if (error.code === 401) {
                return dispatch(doLogout())
            }
            return false;
        }
    );
}



/**
 * Converts from a set of items with inWorkSession true /false to
 * one workSession targetProp: added or removed
 * @param targetProp
 * @param mutations
 * @param prop
 * @returns {{}}
 */
function toWorkSession(targetProp, mutations, prop) {
    let addedItems = [];
    let removedItems = [];
    mutations
    .filter(m => m.get(prop, MutationConstants.UNMODIFIED) != MutationConstants.UNMODIFIED)
    .forEach((m,  id) => {
        if (m.getIn([prop, MutationConstants.SET])===true) {
            addedItems.push(id);
        } else {
            removedItems.push(id);
        }
    });
    if ( !addedItems.length && !removedItems.length ) {
        return {};
    }
    return {
        [targetProp]: {
            'added':addedItems,
            'removed':removedItems,
        }
    }

}

export const _saveWorkSession = (editorId) => (dispatch, getState) => {
    const currentWorkSessionId = getState().currentWorkSessionState.getIn([Keys.StoreSliceData.CURRENT_WORK_SESSION,Keys.ID], null);
    if ( !currentWorkSessionId) {
        return [];
    }
    const itemMutations = getState().mutationsState.getIn([editorId, Keys.MutationType.ITEM], Immutable.Map());
    const assigneeMutations = getState().mutationsState.getIn([editorId, Keys.MutationType.ASSIGNEE],Immutable.Map());
    const workSessionItemsMutation = toWorkSession('itemIds', itemMutations, Keys.Item.IN_WORK_SESSION);
    const workSessionAssigneeMutation = toWorkSession('assigneeIds', assigneeMutations, Keys.Assignee.IN_WORK_SESSION);
    const mergedPatch = { ...workSessionAssigneeMutation, ...workSessionItemsMutation};

    if ( _.isEmpty(mergedPatch)) {
        return [];
    }

    dispatch({type: Actions.PATCH_WORK_SESSION+'_REQUEST'});
    return api.patchWorkSession(currentWorkSessionId, {[currentWorkSessionId]:mergedPatch}).then(response => {
        dispatch({type: Actions.PATCH_WORK_SESSION+'_SUCCESS', payload: {[Keys.StoreSliceData.CURRENT_WORK_SESSION]: response.data[0]}});
        // send the actual data, so that items and assignees can update their IN_WORK_SESSION
        dispatch(
            {
                type:Actions.CURRENT_WORK_SESSION_UPDATED,
                payload:{
                    [Keys.StoreSliceData.CURRENT_WORK_SESSION]:getState().currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION)
                }
            }

        );
        var result = [];
        if (!_.isEmpty(workSessionAssigneeMutation)) {
            result.push(Keys.MutationType.ASSIGNEE);
        }
        if (!_.isEmpty(workSessionItemsMutation)) {
            result.push(Keys.MutationType.ITEM);
        }
        return result;
    }).catch(error => {
        dispatch({type: Actions.PATCH_WORK_SESSION+'_FAILURE', payload: {message: error.message}});
        if (error.code === 401) {
            return dispatch(doLogout())
        }
        return false; // signals failure
    });

};

/**
 * Will execute separate api calls for each entity type
 * and wait for all completing. If any succeeds,
 * neutralizes mutations
 * @param worksession
 * @param items
 * @param assignees
 */

/**
 * Calls relevant api calls to save the mutations of
 * references editor and neutralizes mutations upon
 * (even partial) success
 * @param editorId
 */
export const saveEditor = (editorId) => (dispatch, getState) => {

    // Now neutralize mutations in all editors (is applicable)
    const toSave = [
        _saveWorkSession(editorId),
        _saveItems(editorId),
        _saveAssignees(editorId),
    ];
    return Promise.all(toSave.map(s => dispatch(s))).then(result => {
        const savedTypes = _.uniq(_.flatten(_.compact(result)))
        if ( savedTypes.indexOf(Keys.MutationType.ASSIGNEE)!=-1) {
            dispatch({
                type:Actions.MUTATIONS_NEUTRALIZE,
                payload:{
                    itemType: Keys.MutationType.ASSIGNEE,
                    items: getState().assigneesState.get(Keys.StoreSliceData.ASSIGNEES)}
            });
        }
        if ( savedTypes.indexOf(Keys.MutationType.ITEM)!=-1) {
            dispatch({
                type:Actions.MUTATIONS_NEUTRALIZE,
                payload:{
                    itemType: Keys.MutationType.ITEM,
                    items: getState().itemsState.get(Keys.StoreSliceData.ITEMS)}
            });
        }
        if ( result.find(r => r === false)) {
            // something went horribly wrong
            // notify
        }

    })

};



// WEBPACK FOOTER //
// ./src/model/action-creators/mutation-actions.js